import type {KilnLayout} from '@domain/kiln-monitoring'

import {checkIsNameSetUp, checkKilnPartBoundaries} from './utils'

import type {KilnConfiguration} from '@kilnfeature/types'

export const getIsStationsConfigValid = (
  kilnLayout: KilnLayout,
  kilnConfiguration: KilnConfiguration
) => {
  const kilnLength = Number(kilnConfiguration.dimensions.length) ?? 0

  const isMoreThanOneStation = kilnLayout.stations.length > 1
  let areStationsNamesSetUp = true
  let areStationsBoundariesSetUp = true

  kilnLayout.stations.forEach((station) => {
    if (!checkIsNameSetUp(station.name)) areStationsNamesSetUp = false
    if (!checkKilnPartBoundaries(station, kilnLength)) areStationsBoundariesSetUp = false
  })

  const isStationsConfigValid =
    isMoreThanOneStation && areStationsNamesSetUp && areStationsBoundariesSetUp

  return {
    isStationsConfigValid,
    details: {isMoreThanOneStation, areStationsNamesSetUp, areStationsBoundariesSetUp}
  }
}
